export enum StatusCSSClassEnum {
  true = "true",
  false = "false",
}

export enum StatusTextEnum {
  true = "Acesso permitido",
  false = "Acesso bloqueado",
}
